import moment from 'moment'

export default {
  filters: {
    momentDate: function (val) {
      if (val) {
        return moment(val).format('YYYY/M/D')
      }
    },
    momentDateTime: function (val) {
      if (val) {
        return moment(val).format('YYYY年M月D日 HH時mm分')
      }
    },
    jpyPriceNotation: function (value) {
      if (!value) return ''

      return '¥ ' + value.toLocaleString()
    }
  }
}
